// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IExpiryDate } from './IExpiryDate';
import {
    IExpiryDateFromJSON,
    IExpiryDateFromJSONTyped,
    IExpiryDateToJSON,
    IExpiryDateToJSONTyped,
} from './IExpiryDate';
import type { IAddress } from './IAddress';
import {
    IAddressFromJSON,
    IAddressFromJSONTyped,
    IAddressToJSON,
    IAddressToJSONTyped,
} from './IAddress';

/**
 * 
 * @export
 * @interface ICredit
 */
export interface ICredit {
    /**
     * 
     * @type {string}
     * @memberof ICredit
     */
    card_number: string;
    /**
     * 
     * @type {string}
     * @memberof ICredit
     */
    name_on_card: string;
    /**
     * 
     * @type {string}
     * @memberof ICredit
     */
    card_type: ICreditCardTypeEnum;
    /**
     * 
     * @type {IAddress}
     * @memberof ICredit
     */
    billing_address: IAddress;
    /**
     * 
     * @type {IExpiryDate}
     * @memberof ICredit
     */
    expiry_date: IExpiryDate;
}

/**
* @export
* @enum {string}
*/
export enum ICreditCardTypeEnum {
    AMEX = 'AMEX',
    DISCOVER = 'DISCOVER',
    MASTERCARD = 'MASTERCARD',
    PLCC = 'PLCC',
    VISA = 'VISA',
    OTHER = 'OTHER'
}


/**
 * Check if a given object implements the ICredit interface.
 */
export function instanceOfICredit(value: object): value is ICredit {
    if (!('card_number' in value) || value['card_number'] === undefined) return false;
    if (!('name_on_card' in value) || value['name_on_card'] === undefined) return false;
    if (!('card_type' in value) || value['card_type'] === undefined) return false;
    if (!('billing_address' in value) || value['billing_address'] === undefined) return false;
    if (!('expiry_date' in value) || value['expiry_date'] === undefined) return false;
    return true;
}

export function ICreditFromJSON(json: any): ICredit {
    return ICreditFromJSONTyped(json, false);
}

export function ICreditFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICredit {
    if (json == null) {
        return json;
    }
    return {
        
        'card_number': json['cardNumber'],
        'name_on_card': json['nameOnCard'],
        'card_type': json['cardType'],
        'billing_address': IAddressFromJSON(json['billingAddress']),
        'expiry_date': IExpiryDateFromJSON(json['expiryDate']),
    };
}

export function ICreditToJSON(json: any): ICredit {
    return ICreditToJSONTyped(json, false);
}

export function ICreditToJSONTyped(value?: ICredit | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'cardNumber': value['card_number'],
        'nameOnCard': value['name_on_card'],
        'cardType': value['card_type'],
        'billingAddress': IAddressToJSON(value['billing_address']),
        'expiryDate': IExpiryDateToJSON(value['expiry_date']),
    };
}

